export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: "新闻" | "活动公告";
  tags: string[];
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "森泽佳奈全新音乐专辑《潮汐》正式发行",
    date: "2026-10-08",
    category: "新闻",
    tags: ["音乐", "专辑"],
    summary:
      "历时两年打磨，森泽佳奈第三张个人专辑《潮汐》正式上线，以海洋与光影为线索，收录十首全新作品。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20moody%20ocean%20horizon%20at%20dusk%20with%20deep%20navy%20blue%20water%20and%20warm%20amber%20light%20reflections%2C%20minimal%20elegant%20composition%2C%20soft%20studio%20atmosphere%2C%20high%20detail%2C%20refined%20artistic%20mood&width=800&height=500&seq=news-cover-01&orientation=landscape",
    content: [
      "森泽佳奈第三张个人专辑《潮汐》于 10 月 8 日正式发行。专辑共收录十首作品，围绕海洋、光影与时间三个主题展开，是她迄今为止在音乐表达上最为完整的一次尝试。",
      "整张专辑由森泽佳奈亲自参与词曲创作与编曲讨论，主打曲《潮汐》以钢琴与弦乐铺陈，配合她极具辨识度的声线，营造出辽阔而克制的情绪空间。",
      "专辑视觉由长期合作的摄影团队打造，以深蓝与暖橙的对比色调呈现潮起潮落的意象。森泽佳奈表示，希望听众在聆听时能感受到一种缓慢而坚定的力量。",
      "《潮汐》上线首日即在多个数字音乐平台收获大量好评，被乐评人评价为「兼具流行质感与艺术野心」的作品。实体专辑亦同步开启预售。",
      "为配合专辑发行，森泽佳奈将在年底展开一系列小型现场演出，演出信息将通过官方网站与社交平台陆续公布。",
    ],
  },
  {
    id: "news-2",
    title: "影视新作《静默之城》定档，森泽佳奈担纲主演",
    date: "2026-09-28",
    category: "新闻",
    tags: ["影视", "电影"],
    summary:
      "由森泽佳奈主演的悬疑电影《静默之城》正式定档，她在片中挑战一位在喧嚣都市中寻找真相的调查记者。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20misty%20modern%20city%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%2C%20deep%20navy%20tones%20and%20amber%20accents%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20moody%20atmosphere&width=800&height=500&seq=news-cover-02&orientation=landscape",
    content: [
      "电影《静默之城》正式宣布定档。影片由森泽佳奈领衔主演，讲述一位调查记者在喧嚣都市中追踪一桩尘封旧案的故事。",
      "为了贴近角色，森泽佳奈在开拍前进行了为期一个月的实地走访与体能训练，并在拍摄期间坚持完成多场高强度的情绪戏份。",
      "导演在采访中表示，森泽佳奈的表演为影片注入了「安静却极具张力」的气质，许多镜头几乎依靠她的微表情完成叙事。",
      "影片已在多个国际影展进行内部试映，收获了关于表演与摄影的高度评价。正式上映后，森泽佳奈也将参与多场观众交流活动。",
    ],
  },
  {
    id: "news-3",
    title: "森泽佳奈受邀出席东京国际电影节",
    date: "2026-09-15",
    category: "活动公告",
    tags: ["活动", "电影节"],
    summary:
      "森泽佳奈将以作品主创身份出席东京国际电影节，参与红毯、映后交流及主题论坛等多项活动。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20an%20elegant%20red%20carpet%20entrance%20at%20night%20with%20soft%20spotlights%20and%20deep%20navy%20backdrop%2C%20warm%20amber%20glow%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20festival%20atmosphere&width=800&height=500&seq=news-cover-03&orientation=landscape",
    content: [
      "森泽佳奈确认受邀出席东京国际电影节，并将以《静默之城》主创身份参与红毯及映后交流环节。",
      "除影片宣传外，她还受邀参加一场关于「表演与城市记忆」的主题论坛，与其他创作者共同探讨影像如何记录时代情绪。",
      "主办方表示，森泽佳奈近年来在影视与音乐领域的跨媒介探索，与本届电影节关注的创作趋势高度契合。",
      "相关活动的具体时间与参与方式将在电影节官方渠道公布，官方网站也将持续跟进报道。",
    ],
  },
  {
    id: "news-4",
    title: "个人巡演《森泽佳奈 · 光影之旅》官宣",
    date: "2026-08-30",
    category: "活动公告",
    tags: ["活动", "巡演"],
    summary:
      "森泽佳奈宣布启动个人巡演《光影之旅》，首轮将在五座城市举行，带来专辑《潮汐》的完整现场呈现。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20an%20empty%20concert%20stage%20with%20dramatic%20beam%20lights%20in%20deep%20blue%20and%20warm%20orange%2C%20hazy%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20artistic%20mood&width=800&height=500&seq=news-cover-04&orientation=landscape",
    content: [
      "森泽佳奈正式公布个人巡演计划《光影之旅》，首轮演出将在五座城市举行，以专辑《潮汐》为主线展开完整现场呈现。",
      "巡演以「光影」为核心视觉概念，舞台设计将结合投影、灯光与现场乐队，营造沉浸式的观演体验。",
      "森泽佳奈透露，演出曲目除新专辑作品外，也会重新编排早期代表作，并首次尝试以弦乐四重奏形式演绎部分歌曲。",
      "门票信息与开票时间将陆续公布，粉丝可通过官方网站获取最新动态与优先购票提示。",
    ],
  },
  {
    id: "news-5",
    title: "《潮汐》首周登顶数字音乐榜",
    date: "2026-08-18",
    category: "新闻",
    tags: ["音乐", "榜单"],
    summary:
      "专辑《潮汐》发行首周即登上多个数字音乐平台榜单前列，主打曲进入实时热歌榜前十。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20abstract%20sound%20wave%20visuals%20in%20deep%20navy%20blue%20with%20warm%20amber%20highlights%2C%20smooth%20flowing%20curves%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20elegant%20studio%20atmosphere&width=800&height=500&seq=news-cover-05&orientation=landscape",
    content: [
      "专辑《潮汐》发行首周表现亮眼，登上多个数字音乐平台专辑榜前列，主打曲《潮汐》进入实时热歌榜前十。",
      "上线三天内，专辑相关话题在社交平台的讨论量持续攀升，多首作品被听众自发剪辑为影像片段进行二次传播。",
      "乐评人指出，《潮汐》在流行旋律与艺术表达之间取得了难得的平衡，是森泽佳奈音乐成熟度的重要标志。",
      "团队表示，感谢听众的支持，后续将推出更多现场版本与特别企划，以回馈关注这张专辑的朋友。",
    ],
  },
  {
    id: "news-6",
    title: "森泽佳奈担任公益项目「蓝海计划」形象大使",
    date: "2026-07-22",
    category: "活动公告",
    tags: ["活动", "公益"],
    summary:
      "森泽佳奈受邀担任海洋环保公益项目「蓝海计划」形象大使，将参与系列宣传与线下净滩行动。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20calm%20turquoise%20sea%20surface%20meeting%20a%20clean%20sand%20beach%20at%20soft%20dawn%2C%20deep%20navy%20and%20warm%20amber%20accent%20tones%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20serene%20mood&width=800&height=500&seq=news-cover-06&orientation=landscape",
    content: [
      "森泽佳奈受邀担任海洋环保公益项目「蓝海计划」的形象大使，将在未来一年内参与系列宣传片拍摄与线下净滩行动。",
      "她表示，海洋与潮汐一直是自己创作中重要的灵感来源，能够以实际行动回馈自然是一件非常有意义的事。",
      "项目方介绍，「蓝海计划」旨在提升公众对海洋生态的关注，森泽佳奈的加入将帮助项目触达更多年轻群体。",
      "首批公益活动将于秋季启动，报名与参与方式将通过项目官方渠道发布。",
    ],
  },
  {
    id: "news-7",
    title: "幕后纪录片《镜头之外》上线",
    date: "2026-06-30",
    category: "新闻",
    tags: ["影视", "纪录片"],
    summary:
      "记录森泽佳奈创作日常的幕后纪录片《镜头之外》上线，呈现影视与音乐幕后最真实的一面。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20professional%20film%20camera%20and%20lighting%20equipment%20on%20a%20quiet%20set%20at%20night%2C%20deep%20navy%20shadows%20with%20warm%20amber%20glow%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20behind%20the%20scenes%20mood&width=800&height=500&seq=news-cover-07&orientation=landscape",
    content: [
      "幕后纪录片《镜头之外》正式上线，以纪实视角记录森泽佳奈在影视拍摄与音乐制作过程中的日常状态。",
      "纪录片拍摄历时近半年，跟随她往返片场与录音室之间，收录了大量排练、讨论与休息间隙的真实片段。",
      "片中，森泽佳奈谈及自己对创作的理解，坦言「每一次把作品交出去，都是一次重新认识自己的过程」。",
      "团队表示，希望通过这部纪录片，让观众看到作品背后那些安静而漫长的努力。",
    ],
  },
  {
    id: "news-8",
    title: "音乐单曲《晚风》发布，尝试全新编曲风格",
    date: "2026-06-05",
    category: "新闻",
    tags: ["音乐", "单曲"],
    summary:
      "全新单曲《晚风》上线，森泽佳奈首次尝试轻电子与民谣融合的编曲方向，带来清爽的夏日听觉体验。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20soft%20evening%20breeze%20through%20flowing%20sheer%20curtains%20in%20deep%20navy%20and%20warm%20amber%20light%2C%20minimal%20elegant%20composition%2C%20gentle%20serene%20atmosphere%2C%20high%20detail%2C%20artistic%20mood&width=800&height=500&seq=news-cover-08&orientation=landscape",
    content: [
      "全新单曲《晚风》正式上线，这是森泽佳奈首次尝试将轻电子元素与民谣编曲相融合的作品。",
      "歌曲以简约的吉他律动为基底，叠加轻盈的合成器音色，勾勒出夏夜微风的画面感。",
      "森泽佳奈表示，这首歌是写给每一个在夏日夜晚散步的人，希望听众能从中获得片刻的放松。",
      "单曲同步上线多个音乐平台，并配套发布了一支以自然光影为主题的视觉影像。",
    ],
  },
];